/** Platform branding — Batos IT CodeHub */
export const PLATFORM_NAME = 'Batos IT CodeHub';
export const PLATFORM_SHORT = 'CodeHub';
export const ORG_NAME = 'Batos IT';
export const SUPPORT_EMAIL = 'connect@batosit.com';
export const PLATFORM_URL = 'https://codeninja.batosit.com';
export const PLATFORM_LOGO = '/newlogo.png';

export const copyrightLine = (year = new Date().getFullYear()) =>
  `© ${year} ${ORG_NAME}. All rights reserved.`;
